import { z } from "zod";
import { isoDateTimeSchema } from "./profile.js";
import { serverRegionSchema, serverStatusSchema } from "./server.js";
/**
 * One backing instance of the shared public network. Instances are ordinary
 * core deployments — same status vocabulary as a dedicated `servers/{id}`
 * server — just owned collectively rather than by one user.
 */
export const globalNetworkInstanceSchema = z.object({
    id: z.string().min(1),
    region: serverRegionSchema,
    status: serverStatusSchema,
    createdAt: isoDateTimeSchema,
});
/** Aggregate health. Derived from the instance list; never set independently. */
export const globalNetworkStateSchema = z.enum(["provisioning", "healthy", "degraded", "offline"]);
export const globalNetworkUsageSchema = z.object({
    totalSubspaces: z.number().int().min(0),
    totalSubscribers: z.number().int().min(0),
    totalConnections: z.number().int().min(0),
});
export const globalNetworkCostSchema = z.object({
    currency: z.literal("USD"),
    monthToDateCents: z.number().int().min(0),
    projectedMonthlyCents: z.number().int().min(0),
});
export const globalNetworkActivityEntrySchema = z.object({
    id: z.string().min(1),
    message: z.string().min(1).max(280),
    occurredAt: isoDateTimeSchema,
});
/**
 * The singleton `globalNetwork/singleton` record: the shared public
 * multi-tenant network, as opposed to a user's dedicated single-instance
 * server. Admin-only; never exposed to non-admin callers.
 */
export const globalNetworkSchema = z.object({
    id: z.literal("singleton"),
    state: globalNetworkStateSchema,
    instances: z.array(globalNetworkInstanceSchema),
    usage: globalNetworkUsageSchema,
    cost: globalNetworkCostSchema,
    activity: z.array(globalNetworkActivityEntrySchema),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
/** `network: null` means the global network hasn't been created yet. */
export const getGlobalNetworkResponseSchema = z.object({
    network: globalNetworkSchema.nullable(),
});
export const createGlobalNetworkResponseSchema = z.object({
    network: globalNetworkSchema,
});
//# sourceMappingURL=global-network.js.map